import { useState } from 'react';

export default function useToken() {
    const getToken = () => {
        const tokenString = localStorage.getItem('token');
        console.log(tokenString)
        const userToken = JSON.parse(tokenString || 'null');
        // const userToken = JSON.parse('null');
        return userToken?.token
    };
    const [token, setToken] = useState(getToken());

    const saveToken = userToken => {
        localStorage.setItem('token', JSON.stringify(userToken));
        setToken(userToken.token);
    };

    const clearToken = () => {
        localStorage.setItem('token', '');
        setToken('');
    };

    return {
        token,
        setToken: saveToken,
        clearToken: clearToken
    }

}

